/**
 * ResourceRef nach `04` §4.2 - das einzige systemuebergreifende Bindeglied.
 *
 * Bewusst als erstes Stueck Code des Monorepos: Es ist reines TypeScript ohne
 * jede Abhaengigkeit und damit zugleich der Nachweis, dass die Import-Grenze
 * aus ADR-016 eingehalten werden kann.
 *
 * Ein ResourceRef enthaelt nie ein Token, verleiht nie eine Berechtigung und
 * wird beim Oeffnen erneut am Quellsystem geprueft.
 */

/** Systeme, die eine Ressource fuehren koennen (`01` §1.3). */
export const PROVIDER = [
  "nextcloud",
  "vikunja",
  "paperless",
  "stalwart",
  "portal",
] as const;

export type Provider = (typeof PROVIDER)[number];

export interface ResourceRef {
  readonly tenant: string;
  readonly provider: Provider;
  readonly type: string;
  /** Undurchsichtige Kennung des Quellsystems. Nie als oeffentlicher Link verwenden. */
  readonly opaqueId: string;
}

const MUSTER =
  /^urn:handwerker:([a-z0-9][a-z0-9-]*):([a-z]+):([a-z][a-z0-9-]*):(.+)$/;

/** Formt einen ResourceRef in seine Zeichenkettenform. */
export function formatResourceRef(ref: ResourceRef): string {
  return `urn:handwerker:${ref.tenant}:${ref.provider}:${ref.type}:${ref.opaqueId}`;
}

/**
 * Liest einen ResourceRef. Gibt `undefined` zurueck statt zu werfen: Ein
 * ungueltiger Verweis ist ein erwartbarer Eingabefall, kein Programmfehler.
 */
export function parseResourceRef(wert: string): ResourceRef | undefined {
  const treffer = MUSTER.exec(wert);
  if (!treffer) return undefined;

  const [, tenant, provider, type, opaqueId] = treffer;
  if (!tenant || !provider || !type || !opaqueId) return undefined;
  if (!(PROVIDER as readonly string[]).includes(provider)) return undefined;

  return { tenant, provider: provider as Provider, type, opaqueId };
}
